import { useMutation } from "react-query";
import { addAgencyMapping } from "../../../../../actions/Utilities/AgencyMapping";

const useAddAgencyMapping = () => {
  return useMutation(addAgencyMapping);
};
export default useAddAgencyMapping;
